export enum InheritanceCaseType{
  CERTIFICATE_OF_INHERITANCE= "CERTIFICATE_OF_INHERITANCE",
  CERTIFICATE_OF_DEATH_AND_WILL = "CERTIFICATE_OF_DEATH_AND_WILL",
  NONE = "NONE"
}
